import React from 'react';

import NoticeHeader from 'components/checkout/modal-notices/notice-headers/notice-header';

const ScoreHeader = () => (
  <NoticeHeader headerImgSrc="/images/checkout/zag-celebration.png">Score!</NoticeHeader>
);

export default ScoreHeader;